import React from 'react';
import { Stack, Text, ControlLink } from '@moda/om';

import './AccountHelpLinks.scss';

const ACCOUNT_HELP_LINKS_CONFIG: {
  label: string;
  url: string;
}[] = [
  {
    label: 'Return Policy',
    url: 'https://help.modaoperandi.com/hc/en-us/articles/211521863-Return-Policy'
  },
  {
    label: 'Returning Your Order',
    url: 'https://help.modaoperandi.com/hc/en-us/articles/210056806-Returning-Your-Order'
  },
  {
    label: 'Refunds',
    url: 'https://help.modaoperandi.com/hc/en-us/articles/210056826-Refunds'
  },
  {
    label: 'Shipping Times & Costs',
    url: 'https://help.modaoperandi.com/hc/en-us/articles/211521843-Shipping-Times-Costs'
  },
  {
    label: 'Taxes & Duties',
    url: 'https://help.modaoperandi.com/hc/en-us/articles/211521823-Taxes-Duties'
  },
  {
    label: 'Site Credit & Promotions',
    url: 'https://help.modaoperandi.com/hc/en-us/articles/210053646-Site-Credit-Promotions'
  },
  {
    label: 'All FAQs',
    url: 'https://help.modaoperandi.com/hc/en-us'
  }
];

export const AccountHelpLinks = () => (
  <Stack alignItems="flex-start" space={2}>
    <Text treatment="body2" color="cement">
      Need Help?
    </Text>

    {ACCOUNT_HELP_LINKS_CONFIG.map(item => (
      <ControlLink
        className="AccountHelpLinks__link"
        href={item.url}
        key={item.url}
        rel="noopener noreferrer"
        target="_blank"
        underlined={false}
      >
        {item.label}
      </ControlLink>
    ))}
  </Stack>
);
